import { render, staticRenderFns } from "./CreditsNotesList.vue?vue&type=template&id=c2a9f99c&scoped=true&"
import script from "./CreditsNotesList.vue?vue&type=script&lang=js&"
export * from "./CreditsNotesList.vue?vue&type=script&lang=js&"
import style0 from "./CreditsNotesList.vue?vue&type=style&index=0&id=c2a9f99c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2a9f99c",
  null
  
)

export default component.exports